<i18n>
{
  "en": {
    "toolbar": {
      "buttons": {
        "Logout": "Logout"
      }
    }
  },
  "ru": {
    "toolbar": {
      "buttons": {
        "Logout": "Выход"
      }
    }
  }
}
</i18n>

<template>
  <header class="header-component">
    <DxBox direction="row" width="100%">
      <DxItem :ratio="0" :base-size="60">
        <template #default>
          <div class="nav-menu">
            <dx-button
              icon="menu"
              styling-mode="text"
              @click="toggleMenuFunc"
            />
          </div>
        </template>
      </DxItem>

      <DxItem :ratio="0" :base-size="120" class="header-title">
        <template #default>
          <div class="centered-container">
            <router-link :to="appInfo.link" id="app-title-link" class="app-home">
              <img src="../assets/printstat-rgb-icon.png" :height="30" alt="Printstat icon">
              <span class="link-label">{{ appInfo.title }}</span>
            </router-link>
          </div>
        </template>
      </DxItem>

      <DxItem :ratio="2">
        <template #default>
          <div class="centered-container">
            <dx-toolbar :items="items" item-template="test">
              <template #test="{ data }">
                <span>
                  <span class="dx-icon dx-icon-chevronright" />
                  <router-link v-if="data.link && data.deviceID" :to="{ path: data.link, query: { deviceID: data.deviceID }}" class="link-label breadcrumb-item">{{ data.title }}</router-link>
                  <router-link v-else-if="data.link" :to="data.link" class="link-label breadcrumb-item">{{ data.title }}</router-link>
                  <span v-else class="link-label breadcrumb-item">{{ data.title }}</span>
                </span>
              </template>
            </dx-toolbar>
          </div>
        </template>
      </DxItem>

      <DxItem :ratio="0" :base-size="containerProfile">
        <template #default @click="onClick">
          <div class="centered-container">
            <dx-button
              class="user-button"
              styling-mode="text"
            >
              <user-panel :menu-items="userMenuItems" :menu-mode="menuMode" />
            </dx-button>
          </div>
        </template>
      </DxItem>

      <DxItem :ratio="0" :base-size="40" />
    </DxBox>
  </header>
</template>

<script>
import appInfo from "../app-info";

import { DxBox, DxItem } from 'devextreme-vue/box';
import DxToolbar from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";

import UserPanel from "./user-panel";

import DataBacked from './data-backed';

export default {
  props: {
    menuToggleEnabled: Boolean,
    breadcrumb: Array,
    toggleMenuFunc: Function
  },
  mixins: [DataBacked],
  components: {
    DxBox, DxItem, DxToolbar, DxButton, UserPanel
  },
  data() {
    return {
      menuMode: 'context',
      appInfo: {
        title: appInfo.title,
        link: "/home"
      },
      userMenuItems: [
        {
          text: this.$t('toolbar.buttons.Logout'),
          icon: "runner",
          onClick: this.onLogoutClick
        }
      ],
      containerProfile: 200
    };
  },
  computed: {
    appContainerSize() {
      return this.$store.getters.appContainerSize;
    },
    items() {
      return this.breadcrumb.map(item => {
        const options = {
          template: 'test',
          location: 'before',
          locateInMenu: 'auto'
        };
        return {...item, ...options}
      });
    }
  },
  methods: {
    onClick() {
      this.menuMode = this.menuMode === 'context' ? 'list' : 'context';
    },
    async onLogoutClick() {
      // http://cronus.nicotech.ru:8888/issue/NIC165-17#focus=Comments-73-34810.0-0
      // Muravyev Andrey написал(а) комментарий 22 февр. 2022 10:11
      // По кнопке логаут в интерфейсе предлагаю забывать логин-пароль из стореджа
      // await logout();
      this.$store.commit("setToken", "");
      this.$store.commit("setUser", {});
      this.$router.push({
        path: "/login-form",
        query: { redirect: this.$route.path }
      });
    },
  },
  created() {},
  watch: {
    appContainerSize() {
      const containerProfile = document.querySelector('.user-button');
      this.containerProfile = containerProfile ? containerProfile.clientWidth : 200;
    }
  }
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 152;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 10px 0;

  .dx-box-flex.dx-box.dx-widget.dx-collection .dx-item {
    margin: 0;
    text-wrap: nowrap;
  }

  .centered-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .link-label {
    font-size: 20px;
  }

  .nav-menu {
    display: flex;
    align-items: center;
    justify-content: center;

    .dx-icon {
      color: $base-accent;
    }
  }

  .app-home {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 5px;
  }
}

#app-title-link,
#app-title-link:visited,
.breadcrumb-item,
.breadcrumb-item:visited {
  text-decoration: none;
  color: #000 !important;
}
.dx-toolbar .dx-icon-chevronright {
  margin: 0 8px;
}

</style>
